export default __webpack_public_path__ + "static/media/linkedin.bfd01486.svg";